

function BlogalertData(props)

{
    return(
    
        <div className="t-card">

            <div className="t-image">

                <img src={props.img} alt="img"/>

            </div>

            <h4>{props.heading}</h4>
            <p>{props.text}</p>

        </div>
                 
        

            
   
        
        

   

    );
}
export default BlogalertData;